import React, {ChangeEvent, ComponentProps, ReactNode} from 'react';
import {DataItem} from './DataItem';

export * from './DataItem';

export default DataItem;

interface DataItemProps extends ComponentProps<'input'> {
  fieldId: string;
  onChange?: (e: ChangeEvent) => void;
  containerStyle: string;
  sideLabelStyle: string;
  inputContainerStyle: string;
  sideLabel: ReactNode;
}

export const TypedDataItem = DataItem as unknown as React.FC<DataItemProps>;